import { ChangeDetectorRef } from '@angular/core';
import { FrontendLoggerService } from '../../services/frontend-logger.service';

export interface ChatRequestState {
  activeRequests: number;
  isRequesting: boolean;
}

export class ChatRequestTracker {
  constructor(
    private readonly state: ChatRequestState,
    private readonly logger: FrontendLoggerService,
    private readonly changeDetector: ChangeDetectorRef
  ) {}

  start(): void {
    this.state.activeRequests += 1;
    this.state.isRequesting = true;
    try {
      this.logger.info(
        `Spinner ON (activeRequests=${this.state.activeRequests})`,
        'ChatComponent.startRequest'
      );
    } catch {
      // Logging must never affect the spinner.
    }
    this.changeDetector.markForCheck();
  }

  end(): void {
    this.state.activeRequests = Math.max(0, this.state.activeRequests - 1);
    if (this.state.activeRequests === 0) this.state.isRequesting = false;
    try {
      this.logger.info(
        `Spinner check (activeRequests=${this.state.activeRequests})`,
        'ChatComponent.endRequest'
      );
    } catch {
      // Logging must never affect the spinner.
    }
    this.changeDetector.markForCheck();
  }

  endIfStuck(): void {
    if (!this.state.isRequesting || this.state.activeRequests <= 0) return;
    this.logger.warn(
      `Spinner fallback: forzando ocultar (activeRequests=${this.state.activeRequests})`,
      'ChatComponent.endRequestIfStuck'
    );
    this.state.activeRequests = 0;
    this.state.isRequesting = false;
    this.changeDetector.markForCheck();
  }
}
